export default __webpack_public_path__ + "static/media/link-dark.c0e64bdb.png";